import React, { Component } from 'react';
import { Button, Row, Col, Modal, Table, Spin } from 'antd';
import moment from 'moment';
import Columns5 from './components/Columns5';
import { getOrderDomesticDetail } from './api';
import { currency } from './formatNumber';
import './index.less';

const productColumns = [
  {
    title: "商品名称",
    dataIndex: "sku_name",
    width: '33%',
    align: "center",
  },
  {
    title: "砍果价(元/kg)",
    dataIndex: "cut_fruit_price",
    width: '33%',
    align: "center",
    render: (text) => currency(text)
  },
  {
    title: "箱数(箱/柜)",
    dataIndex: "number_of_boxes",
    width: '34%',
    align: "center",
  },
];
const columns = [
  {
    title: "费用名称",
    dataIndex: "key",
    align: "center",
  },
  {
    title: "费用(฿)",
    dataIndex: " value_rate",
    align: "center",
    render: (text, record) => {
      const { value, rate } = record;
      return currency(value * rate);
    }
  },
  {
    title: "单位成本(฿/Box)",
    dataIndex: "value_norms",
    align: "center",
    render: (text, record) => {
      const { value, norms, rate } = record;
      return currency(value * rate / norms);
    }
  },
  {
    title: "费用(RMB)",
    dataIndex: "value",
    align: "center",
    render: text => currency(text)
  },
  {
    title: "单位成本(RMB/Box)",
    dataIndex: "norms",
    align: "center",
    render: (text, record) => {
      const { value, norms } = record;
      return currency(value / norms);
    }
  }
];

export default class QuotationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      moreVisible: false,
      params: {},
      info: {},
      list: [],
      list4: [],
      list5: [],
      loading: true,
      currentSource: [],
      container_num: 1,
      city_name: undefined
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const quotation_no = params.get('quotation_no'), city_name = params.get('city_name'), container_num = params.get('container_num');
    this.setState({ quotation_no, city_name, container_num }, () => {
      this.getOrderDomesticDetailInfo();
    });
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  async getOrderDomesticDetailInfo() {
    this.setState({ location: true });
    const { quotation_no } = this.state;
    const { data: { data = {}, code } } = await getOrderDomesticDetail({ quotation_no });
    if (+code === 0) {
      this.setState({ info: data, loading: false });
    }
  }
  cancel = () => {
    this.props.history.goBack();
  }

  handleModalCancel = () => {
    this.setState({ moreVisible: false });
  }

  openMoreModal = ({ index = 1 }) => {
    const titleConfig = { 1: '第二段CPS加工', 2: '第三段CPS出口' };
    const key = `level${index + 1}_info`;
    const { info } = this.state;
    const currentSource = (info?.[key] || []).map((item, index) => ({ ...item, currentId: index }));
    this.setState({ moreVisible: true, title: titleConfig[index], currentSource });
  }
  formateMoment = (values, value) => {
    const current = values || [];
    let startTime, endTime;
    if (current.length) {
      const [start, end] = current;
      startTime = moment(start).format('YYYY-MM-DD');
      endTime = moment(end).format('YYYY-MM-DD');
    }
    return { [`${value}_start`]: startTime, [`${value}_end`]: endTime };
  }

  render() {
    const { title, moreVisible, info = {}, currentSource = [], container_num = 1, city_name, loading = false } = this.state;
    const { level5_info = [], level4_info = [] } = info;
    const level5_info_value = level5_info.reduce((pre, next) => pre + Number(next.value), 0);
    const transportation_info = (info?.transportation_info || []).filter(item => item.city_name === city_name).map(item => ({
      key: '运费',
      field: 'transportation_cost',
      id: +(new Date()),
      rate: level4_info?.[0]?.rate,
      norms: level4_info?.[0]?.norms,
      value: +item.transportation_cost
    }));
    const finallyLevel4Info = [...level4_info, ...transportation_info];
    const finallyLevel4InfoValue = finallyLevel4Info.reduce((pre, next) =>pre + Number(next.value), 0);
    return (
      <>
        {loading ? <Spin /> :
          <div className='quotation-list'>
            <div className='quotation-list-item'>
              {/* <div className='quotation-list-item-title'>第一段 CPS收果</div> */}
              <div className='quotation-list-item-describe'>
                <Table
                  columns={productColumns}
                  dataSource={info.product_info || []}
                  rowClassName={() => 'editable-row'}
                  rowKey='id'
                  pagination={false}
                />
              </div>
            </div>
            <div className='quotation-list-item'>
              <div className='quotation-list-item-title'>第一段 CPS收果</div>
              <div className='quotation-list-item-describe'>
                <Row>
                  <Col span={8}>砍果成本（元/柜）：{currency(info.fruit_cutting_cost)} </Col>
                  <Col span={8}>单位成本(元/箱)：{currency(info.fruit_cutting_cost / info.cabinet_specification)} </Col>
                  <Col span={8}><Button type="link"></Button></Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <strong>阶段小计：{currency(info.fruit_cutting_cost * Number(container_num))}元</strong>
                    <strong style={{ paddingLeft: '20px' }}>（ {container_num}柜 * {currency(info.fruit_cutting_cost)}元/柜 ）</strong>
                  </Col>
                </Row>
              </div>
            </div>
            <div className='quotation-list-item'>
              <div className='quotation-list-item-title'>第二段CPS加工</div>
              <div className='quotation-list-item-describe'>
                <Row>
                  <Col span={8}>出厂成本（元/柜）：{currency(info.ex_work_cost)} </Col>
                  <Col span={8}>单位成本(元/箱)：{currency(info.ex_work_cost / info.cabinet_specification)}</Col>
                  <Col span={8}><Button type="link" onClick={() => this.openMoreModal({ index: 1 })}>更多</Button></Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <strong>阶段小计：{currency(info.ex_work_cost * Number(container_num))}元</strong>
                    <strong style={{ paddingLeft: '20px' }}>（ {container_num}柜 * {currency(info.ex_work_cost)}元/柜 ）</strong>
                  </Col>
                  <Col span={12}><Button type="link"></Button></Col>
                </Row>
              </div>
            </div>
            <div className='quotation-list-item'>
              <div className='quotation-list-item-title'>第三段CPS出口</div>
              <div className='quotation-list-item-describe'>
                <Row>
                  <Col span={8}>CIF总价（元/柜）:{currency(info.cif_cost)} </Col>
                  <Col span={8}>单位成本(元/箱)：{currency(info.cif_cost / info.cabinet_specification)} </Col>
                  <Col span={8}><Button type="link" onClick={() => this.openMoreModal({ index: 2 })}>更多</Button></Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <strong>阶段小计：{currency(info.cif_cost * Number(container_num))}元</strong>
                    <strong style={{ paddingLeft: '20px' }}>（ {container_num}柜 * {currency(info.cif_cost)}元/柜 ）</strong>
                  </Col>
                  <Col span={12}><Button type="link"></Button></Col>
                </Row>
              </div>
            </div>
            <div className='quotation-list-item'>
              <div className='quotation-list-item-title'>第四阶段卜蜂清关</div>
              <div className='quotation-list-item-describe'>
                {info?.level4_info?.length ? <Columns5 list={finallyLevel4Info || []}></Columns5> : null}
                <Row>
                  <Col span={12}>
                    <strong>阶段小计：{currency(finallyLevel4InfoValue * Number(container_num))}元</strong>
                    <strong style={{ paddingLeft: '20px' }}>（ {container_num}柜 * {currency(finallyLevel4InfoValue)}元/柜 ）</strong>
                  </Col>
                  <Col span={12}><Button type="link"></Button></Col>
                </Row>
              </div>
            </div>
            <div className='quotation-list-item'>
              <div className='quotation-list-item-title'>第五段卜蜂报价</div>
              <div className='quotation-list-item-describe'>
                {info?.level5_info?.length ? <Columns5 list={info?.level5_info || []}></Columns5> : null}
                <Row>
                  <Col span={12}>
                    <strong>阶段小计：{currency(level5_info_value * Number(container_num))}元</strong>
                    <strong style={{ paddingLeft: '20px' }}>（ {container_num}柜 * {currency(level5_info_value)}元/柜 ）</strong>
                  </Col>
                  <Col span={12}><Button type="link"></Button></Col>
                </Row>
                <div>汇率(泰铢/人民币)：{currency(info.exchange_rate)}</div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', margin: '20px auto' }}><Button type='primary' onClick={() => this.props.history.goBack()}>返回</Button></div>
          </div>
        }

        <Modal
          title={title}
          width={'96%'}
          open={moreVisible}
          onCancel={() => this.handleModalCancel()}
          footer={null}
        >
          <Table
            rowClassName={() => 'editable-row'}
            bordered
            dataSource={currentSource}
            columns={columns}
            rowKey='currentId'
            pagination={false}
          />
        </Modal>
      </>
    );
  }
}
